<template>
  <div>
    <Loading v-if="loading" />
    <BaseCheckbox label="Gunakan Talangan Stok Reguler untuk Promo" v-model="reimbursement_active" @change="onChange" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import BaseCheckbox from '../../base/BaseCheckbox.vue';
import { requestMixin } from '../../../mixins/request/request.js';

export default {
  mixins: [requestMixin],
  components: {
    BaseCheckbox
  },
  data() {
    return {
      loading: false,
      reimbursement_active: true
    }
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser'
    })
  },
  methods: {
    ...mapMutations({
      setMe: 'auth/setUser'
    }),
    async onChange() {
      this.loading = true

      const [, err] = await this.request(`/api/v1/offices/${this.me.office_id}`, {
        method: 'patch',
        data: {
          data: {
            type: 'offices',
            id: this.me.office_id,
            attributes: {
              reimbursement_active: this.reimbursement_active
            }
          }
        }
      })

      if (!err) {
        this.setMe({
          ...this.me,
          reimbursement_active: this.reimbursement_active
        })
      }

      this.loading = false
    }
  },
  mounted() {
    this.reimbursement_active = this.me.reimbursement_active
  }
}
</script>